import React, { useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import VideoStyles from "../../constant/videoStyle";


const VideoStyleForm = ({ onClose, getVideoTypes, initialData }) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isDirty },
  } = useForm({
    defaultValues: {
      ...initialData,
    },
  });
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);


  const onSubmit = async (data) => {
    if(!isDirty){
      return;
    }
    setLoading(true);
    try {
      if(initialData?._id){
        await axios.put(
          `${process.env.REACT_APP_API_URL}/update-video-style/${initialData._id}`, 
          data,
          {
            withCredentials: true,
          },
        );
      setSuccessMessage("Video Style Updated!");

      }
      else{
      await axios.post(
        `${process.env.REACT_APP_API_URL}/create-video-style`,
        data,
        {
          withCredentials: true,
        },
      );
      setSuccessMessage("Video Style Created!");

    }
      await getVideoTypes();

      reset();
      setTimeout(() => {
        setSuccessMessage(null);
        onClose();
      }, 2000);
    } catch (err) {
      setErrorMessage(`${err?.response?.data?.message || "An unexpected error occurred."}`);
      setTimeout(() => {
        setErrorMessage(null);
      }, 2000);

    } finally {
      setLoading(false);
    }
  };


 
  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
      {successMessage && (
          <div className="absolute top-0 left-0 right-0 bg-green-500 text-white text-center py-2 rounded-t-lg animate-pulse">
            <div className="flex items-center justify-center">
              <svg 
                className="w-6 h-6 mr-2" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24" 
                xmlns="http://www.w3.org/2000/svg"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" 
                />
              </svg>
              {successMessage}
            </div>
          </div>
        )}
        {errorMessage && (
  <div className="absolute top-0 left-0 right-0 bg-red-500 text-white text-center py-2 rounded-t-lg animate-pulse">
    <div className="flex items-center justify-center">
      <svg 
        className="w-6 h-6 mr-2" 
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth={2} 
          d="M12 8v4m0 4h.01M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2z" 
        />
      </svg>
      {errorMessage}
    </div>
  </div>
)}

      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md relative">
      
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">{initialData ? "Edit Video Style" : "Create Video Style"}</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 focus:outline-none"
          >
            ✖
          </button>
        </div>
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
        <div>
  <label className="block mb-1.5 text-sm font-medium">
    Video Style
  </label>
  <input
    type="text"
    className={`w-full px-3 py-2 border rounded-md outline-none focus:ring-2 focus:ring-blue-500 ${
      errors.videoStyle ? "border-red-500" : "border-gray-300"
    }`}
    {...register("name", { 
      required: "Video style is required", 
      pattern: {
        value: /^[A-Z_]+$/,
        message: "Only uppercase letters (A-Z) and underscores (_) are allowed"
      }
    })}
  />
  {errors.videoStyle && (
    <p className="mt-1 text-sm text-red-500">
      {errors.videoStyle.message}
    </p>
  )}
</div>


          <div className="space-y-2">
            <label
              htmlFor="effort"
              className="block text-sm font-medium text-gray-700"
            >
              Effort Level
            </label>
            <select
              id="effort"
              {...register("effortLevel", {
                required: "Effort level is required",
              })}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="">Select Effort Level</option>
              {[0.5, 1, 1.5, 2, 2.5, 3].map((level) => (
                <option key={level} value={level}>
                  {level}
                </option>
              ))}
            </select>
            {errors.effort && (
              <p className="text-sm text-red-600">{errors.effort.message}</p>
            )}
          </div>

          <button
            type="submit"
            disabled={loading}
            className={`w-full py-2 px-4 rounded-md transition-colors font-medium focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${
              loading
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-blue-500 hover:bg-blue-600 text-white"
            }`}
          >
            {loading ? "Saving..." : "Save"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default VideoStyleForm;
